
class YotpoExpandAttributes {
  static BTN_SELECTOR = 'button.yotpo-custom-questions-see-more-label';
  static WIDGET_SELECTOR = '.yotpo-reviews-main-widget, [data-yotpo-instance-id], .yotpo-widget-instance';
  static POLL_INTERVAL_MS = 500;
  static POLL_MAX_ATTEMPTS = 40;
  static DEBOUNCE_MS = 150;

  #observer = null;
  #debounceTimer = null;

  init() {
    this.#injectStyles();
    if (!this.#attach()) this.#waitForWidget();
  }

  #injectStyles() {
    const style = document.createElement('style');
    style.dataset.jj = 'yotpo-expand-attributes';
    style.textContent = `
      .yotpo-review-customer-questions-container ${YotpoExpandAttributes.BTN_SELECTOR} { display: none !important; }
      .yotpo-review-customer-questions-container .yotpo-custom-questions-wrapper { row-gap: 2px; }
    `;
    document.head.appendChild(style);
  }

  #expandAll(root = document) {
    const buttons = root.querySelectorAll(YotpoExpandAttributes.BTN_SELECTOR);
    buttons.forEach((btn) => {
      if (/see more/i.test(btn.textContent ?? '')) btn.click();
    });
  }

  #attach() {
    const host = document.querySelector(YotpoExpandAttributes.WIDGET_SELECTOR);
    if (!host) return false;

    this.#observer = new MutationObserver(() => {
      clearTimeout(this.#debounceTimer);
      this.#debounceTimer = setTimeout(() => this.#expandAll(), YotpoExpandAttributes.DEBOUNCE_MS);
    });
    this.#observer.observe(host.parentElement ?? document.body, { childList: true, subtree: true });

    this.#expandAll();
    return true;
  }

  // el widget de Yotpo carga async: reintenta un rato y desiste en silencio
  #waitForWidget() {
    let attempts = 0;
    const poll = setInterval(() => {
      if (this.#attach() || ++attempts >= YotpoExpandAttributes.POLL_MAX_ATTEMPTS) clearInterval(poll);
    }, YotpoExpandAttributes.POLL_INTERVAL_MS);
  }
}

new YotpoExpandAttributes().init();
